import { Box, Container, Divider, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material'
import { useState } from 'react'
import { useParams } from 'react-router'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import useSectionData from '../hooks/useSectionData'

const SectionDetail = () => {
  const { section, questionid, type } = useParams<{ section: string; questionid: string; type: string }>()
  const [iQuestion, setIQuestion] = useState<number>(Number(questionid))

  const handleInfo = (iQuestion: number) => {
    setIQuestion(iQuestion)
  }

  const data: any = useSectionData()

  return (
    <Container sx={{ padding: 0, marginTop: 6.25 }} maxWidth="xl">
      {/*<CustomBreadcrumb />*/}
      {section !== undefined && type !== undefined && (
        <Container maxWidth="md">
          <Box
            sx={theme => ({
              display: 'flex',
              flexWrap: 'wrap',
              mt: 7,
              mb: 15,
              [theme.breakpoints.down('sm')]: {
                flexDirection: 'column-reverse'
              }
            })}
          >
            <Box
              sx={theme => ({
                [theme.breakpoints.up('sm')]: {
                  maxWidth: '260px'
                },
                [theme.breakpoints.down('sm')]: {
                  width: '100%',
                  maxWidth: 'max-content'
                }
              })}
            >
              {data[type]
                .filter((sections: any) => sections[section] !== undefined)
                .map((sections: any) => (
                  <div key={sections[section].title}>
                    <Typography variant="subtitle1">{sections[section].title}</Typography>
                    <List component="nav">
                      {sections[section].content.map((section: any, index: number) => (
                        <div key={section.question}>
                          <ListItem disablePadding>
                            <ListItemButton selected={index === iQuestion} onClick={() => handleInfo(index)}>
                              <ListItemText primary={section.question} />
                            </ListItemButton>
                          </ListItem>
                          <Divider />
                        </div>
                      ))}
                    </List>
                  </div>
                ))}
            </Box>

            <Box
              sx={theme => ({
                pb: 4,
                paddingRight: 32,
                [theme.breakpoints.up('sm')]: {
                  paddingLeft: 53,
                  width: 'calc( 100% - 352px)'
                },
                [theme.breakpoints.down('sm')]: {
                  width: '100%',
                  paddingRight: 0,
                  paddingLeft: 0
                }
              })}
            >
              <Box sx={{ mb: 3 }}>
                <ButtonBack />
              </Box>

              {data[type]
                .filter((sections: any) => sections[section] !== undefined)
                .map((sections: any) => (
                  <div key={sections[section].title}>
                    {sections[section].content
                      .filter((_section: any, index: number) => index === iQuestion)
                      .map((section: any) => (
                        <div key={section.question}>
                          <Box sx={{ mb: 7 }}>
                            <Typography variant="h4" sx={{ fontWeight: 300 }}>
                              {section.question}
                            </Typography>
                          </Box>

                          {section.answer.map((answer: any) => (
                            <Typography
                              key={answer}
                              dangerouslySetInnerHTML={{
                                __html: answer
                              }}
                            />
                          ))}
                        </div>
                      ))}
                  </div>
                ))}
            </Box>
          </Box>
        </Container>
      )}
    </Container>
  )
}

export default SectionDetail
